import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import Authentication from './../../../session/index'
import { withRouter } from 'react-router-dom';


class PreviewSMS extends Component {
    constructor(props) {
        super(props);


    }

    render() {
        const { users, totalCredits } = this.props;
        const header2 = (
            <div className="table-header sp-tbl-header">
                <div className="sp-tbl-left">
                    <h2 style={{ color: `${totalCredits > this.props?.user?.user?.smsLimit ? 'red' : 'green'}` }} >Total Credits for this Campaign: {totalCredits}; Available Credits for you: {this.props?.user?.user?.smsLimit} </h2>

                </div>
            </div >
        );
        return (
            <div>
                {
                    users && users.length ? <>
                        <div className="p-grid">
                            <div className="card sp-datatable sp-mt30">
                                <DataTable ref={(el) => this.dt = el}
                                    value={users}
                                    dataKey="phoneNumber"
                                    paginator
                                    rows={10}
                                    rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 300, 500]}
                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products"
                                    //  globalFilter={this.state.globalFilter}
                                    //</div> header={header2}
                                    header={header2}
                                    paginatorLeft={() => {
                                        return <>
                                            <p className='avail-q'>Selected users:  <span>{users.length}</span>  </p>
                                            <p className='avail-q'></p>
                                        </>
                                    }}
                                >
                                    <Column field="phoneNumber" header="Phone Number" />
                                    <Column field="message" header="Message" />
                                    <Column field="language" header="Language" />
                                    <Column field="credits" header="Credits" />
                                </DataTable>
                            </div>
                        </div>
                    </> : null}

            </div>
        )
    }
}






export default PreviewSMS;



